<template>
  <div class="page-active-email align-items-center h-100 mt-5">
    <div class="container h-100">
      <div class="row h-100 justify-content-center align-items-center">
        <div class="col">
          <div class="panel-card p-3 text-center mt-3">
            <app-loading :isFull="false" v-if="isLoading"/>
            <blockquote class="blockquote rtl">
              <p class="mb-2">نتیجه فعال سازی ایمیل:</p>
              <footer class="blockquote-footer">
                <cite title="موفق بود" :class="['text-'+msg.status]">{{msg.text}}</cite>
                <!-- text-danger -->
                <!-- text-warning -->
                <div class="form-action form-action-center mt-4">
                  <router-link
                    to="/v1/login"
                    class="bttn-minimal bttn bttn-primary margin-20"
                    v-ripple
                  >{{$t('button.login')}}</router-link>
                </div>
              </footer>
            </blockquote>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: true,
      activeId: this.$route.params.activeId,
      msg: {
        text: 'لطفا صبر کنید ...',
        state: 'info'
      }
    }
  },
  mounted() {
    this.getActiveUser()
  },
  methods: {
    async getActiveUser() {
      try {
        let { data } = await this.$store.dispatch('auth/userActive', this.activeId)
        if (data.state != 200) {
          this.msg = {
            text: 'مشکلی پیش آمده دوباره تلاش کنید',
            state: 'danger'
          }
          return
        }
        this.msg = {
          text: 'اکانت شما با موفقیت فعال شد',
          status: 'success'
        }
        this.$root.showInfoMsg({
          message: 'اکانت شما با موفقیت فعال شد'
        })
        this.isLoading = false
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="less">
@import (reference) "../../assets/css/variable.less";
.page-active-email {
  position: relative;
  height: calc(100%);
}
</style>



// WEBPACK FOOTER //
// src/pages/active-email/_id.vue